import { SubmitButtonConfig, SubmitButton } from 'ui/components/SubmitButton'
import { termsApi } from 'api'
import { LOCATION_DETAILS_FORM_ID } from 'modules/Locations/constants'
import { SUCCESS_TERMS_UPDATE } from 'texts/termsAndConditions'

const termsConfig: SubmitButtonConfig = {
  formId: LOCATION_DETAILS_FORM_ID,
  completeApiRequest: (companyId) =>
    termsApi.completeTermsAndConditions(Number(companyId)),
  successMessage: SUCCESS_TERMS_UPDATE,
  pageStatusKey: 'termsConditionsStatus',
  withoutDisabled: true,
  textKey: 'TERMS',
}

export const TermsSubmitButton = () => <SubmitButton config={termsConfig} />
